exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submission-page-preview iframe{width:70em;max-width:100%;height:36em;max-height:48%}.titleoflink{max-width:1200px;padding-right:20px;word-break:normal}.imageoflink{max-width:260px;margin:auto;margin-right:0;margin-top:0}.summary{max-width:680px;width:100%;display:inline-block;padding-top:10px}@media (max-width:600px){.imageoflink{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-109be82d","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/submission/LinkSubmission.vue
// module id = H9OO
// module chunks = 0